
import React from 'react';
import FontSizeSelector, { FontSizeOption } from '@/components/ui/FontSizeSelector';

const ALL_ITEMS = [
  { key: 'חומש יומי', label: 'חומש יומי' },
  { key: 'תהילים יומי', label: 'תהילים יומי' },
  { key: 'תניא יומי', label: 'תניא יומי' },
  { key: 'רמב״ם - שלושה פרקים', label: 'רמב״ם - ג׳ פרקים' },
  { key: 'רמב״ם - פרק אחד', label: 'רמב״ם - פרק אחד' },
  { key: 'המצווה היומית', label: 'ספר המצוות' }
];

interface DailyStudyEditorProps {
  content: any;
  onContentChange: (field: string, value: any) => void;
}

const DailyStudyEditor: React.FC<DailyStudyEditorProps> = ({ content, onContentChange }) => {
  const selected = content?.selectedItems || ALL_ITEMS.map(item => item.key);
  const fontSize: FontSizeOption = content?.fontSize || 'md';

  const handleToggle = (key: string) => {
    let updated: string[];
    if (selected.includes(key)) {
      updated = selected.filter(k => k !== key);
    } else {
      updated = [...selected, key];
    }
    onContentChange('selectedItems', updated);
  };

  const handleFontSizeChange = (value: FontSizeOption) => {
    onContentChange('fontSize', value);
  };

  return (
    <div>
      <h3 className="font-bold mb-2">בחר אילו שיעורים להציג</h3>
      <FontSizeSelector value={fontSize} onChange={handleFontSizeChange} label="גודל גופן לכרטיסים" />
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2">
        {ALL_ITEMS.map(item => (
          <label key={item.key} className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={selected.includes(item.key)}
              onChange={() => handleToggle(item.key)}
            />
            <span>{item.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default DailyStudyEditor;
